'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-33c20ec4.js');
var React = require('react');
var jsUtils = require('@swiggy-private/js-utils');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const useTheme = require("styled-components").useTheme;
const GenericIcon = (_a) => {
    var { Icon, ariaLabel, strokeColor = "text_Highest_Emphasis", fillColor = "text_Highest_Emphasis" } = _a, props = tslib_es6.__rest(_a, ["Icon", "ariaLabel", "strokeColor", "fillColor"]);
    const theme = useTheme();
    const strokeColorValue = theme.colors[theme.colorMode][strokeColor];
    const colorValue = theme.colors[theme.colorMode][fillColor];
    const isDecorative = React.useMemo(() => jsUtils.isEmpty(ariaLabel), [ariaLabel]);
    return (React__default['default'].createElement("div", Object.assign({ style: { lineHeight: 0 } }, props),
        React__default['default'].createElement(Icon, { "aria-label": ariaLabel, "aria-hidden": isDecorative, strokeColor: strokeColorValue, fillColor: colorValue })));
};

exports.GenericIcon = GenericIcon;
//# sourceMappingURL=index.js.map
